import { useExtendedTelegramMutation } from '../../SocialAuth/SocialAuthLogin/Telegram/graphql/ExtendedTelegramMutation.generated';
import filterAuthResponse from '../helpers/utils';

const useHandleTelegramAuthenticate = () => {
  const [completeTelegramRegistration, { loading }] =
    useExtendedTelegramMutation();
  const handleTelegramAuthenticate = async (
    variables: AuthVariables,
    accessToken: string,
  ) => {
    const response = await completeTelegramRegistration({
      variables: {
        ...variables,
        telegramData: accessToken,
      },
    });
    return filterAuthResponse(response?.data?.userManagementAuthWithTelegram);
  };
  return {
    handleTelegramAuthenticate,
    loading,
  };
};

export default useHandleTelegramAuthenticate;
